import { render, staticRenderFns } from "./Kemampuan.vue?vue&type=template&id=24b37934&"
import script from "./Kemampuan.vue?vue&type=script&lang=js&"
export * from "./Kemampuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports